import { GlobalServiceService } from "src/app/services/global-service.service";
import { Subscription } from "rxjs";
import { LocalstorageService } from "./services/localstorage.service";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ApiBasic } from "./services/api-basic";
@Injectable({
  providedIn: "root",
})
export class LoginService {
  private httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };
  subscription: Subscription;
  appBase: any;
  private token = "";
  constructor(
    public http: HttpClient,
    private app: ApiBasic,
    public _global: GlobalServiceService,
    private _localstorage: LocalstorageService
  ) {
    // this.subscription = this._localstorage.getMessage().subscribe(message => {
    //   this._global.base_url = localStorage.getItem('base_url')

    // });

    this._global.base_url = this._global.base_url;
    this.token = _global.token;
    this.subscription = this._localstorage.getToken().subscribe((message) => {
      this.token = _global.token;
    });
  }

  makeLogin(data) {
    const queryData = this.app.stringfyObject(data);

    return this.http.get(
      this._global.base_url + "/signin?" + queryData,
      this.httpOptions
    );
  }
  refreshInfo(data) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };

    return this.http.get(
      this._global.base_url + "/users/" + data + "/summaryinfo",
      {}
    );
  }

  public recoverPassword(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.post(
      this._global.base_url + "/users/recovery-password",
      data,
      {}
    );
  }

  checkToken() {
    // if (localStorage.getItem("userInfoEncrypted")["username"]) {
      const data = {
        username: atob(
          JSON.parse(localStorage.getItem("userInfoEncrypted"))["username"]
        ),
        password: atob(
          JSON.parse(localStorage.getItem("userInfoEncrypted"))["password"]
        ),
      };

      return this.http.post(this._global.base_url + "/v5/token", data, {});
    // }
  }
  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }
}
